// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PVerticalAlignBottomOutlinedSvg from "@fishx/icons-svg/es/asn/PVerticalAlignBottomOutlined";
import FishxIcon from '../components/FishxIcon';

var PVerticalAlignBottomOutlined = function PVerticalAlignBottomOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PVerticalAlignBottomOutlinedSvg
  }));
};

PVerticalAlignBottomOutlined.displayName = 'PVerticalAlignBottomOutlined';
export default React.forwardRef(PVerticalAlignBottomOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PVerticalAlignBottomOutlined.js
// module id = 3722
// module chunks = 0